/**
 * @module ol-kmz
 */
import JSZip from 'jszip';
import { KML } from 'ol/format';

/**
 * @description
 * These functions add the ability to unzip KMZ files and read the KML data
 * using the JSZip library and the ol/format/KML class. They require version
 * 2.6.1 of JSZip; I was not able to get version 3 of JSZip to work.
 */
let zip = new JSZip();

function getKMLData(buffer) {
  let kmlData;
  zip.load(buffer);
  const kmlFiles = zip.file(/\.kml$/i);
  const kmlFile = kmlFiles[kmlFiles.length - 1];
  if (kmlFile) {
    kmlData = kmlFile.asText();
  }
  return kmlData;
}

function getKMLImage(href) {
  const index = window.location.href.lastIndexOf('/');
  if (index !== -1) {
    const kmlFile = zip.file(href.slice(index + 1));
    if (kmlFile) {
      return URL.createObjectURL(new Blob([kmlFile.asArrayBuffer()]));
    }
  }
  return href;
}

/**
 * Define a KMZ format class by sub-classing ol/format/KML
 */
export class KMZ extends KML {
  constructor(opt_options) {
    const options = opt_options || {};
    options.iconUrlFunction = getKMLImage;
    super(options);
  }

  getType() {
    return 'arraybuffer';
  }

  readFeature(source, options) {
    const kmlData = getKMLData(source);
    return super.readFeature(kmlData, options);
  }

  readFeatures(source, options) {
    const kmlData = getKMLData(source);
    return super.readFeatures(kmlData, options);
  }

  kmlText(source, options) {
    const kmlData = getKMLData(source);
    return kmlData;
  }
}

// KMZ is exported in the class definition
